import emergAccident from '../../../assets/emergency/accident_help.jpg';
import emergRoadside from '../../../assets/emergency/roadside_Assistance.jpg';
import emergTowing from '../../../assets/emergency/towing_assistance.jpg';
import emergLockout from '../../../assets/emergency/vehicle_lockout.jpg';
import legalConsultation from '../../../assets/legal_immigration_Assistance/legal_consultation.jpg';
import legalTraffic from '../../../assets/legal_immigration_Assistance/traffic_ticket.jpg';
import legalFraud from '../../../assets/legal_immigration_Assistance/fraud_dispute.jpg';
import legalImmigration from '../../../assets/legal_immigration_Assistance/immigration.jpg';
import afTax from '../../../assets/accounting_financial_Services/tax-credits-claim-return-deduction-refund-concept.jpg';
import afInsurance from '../../../assets/accounting_financial_Services/insurance.jpg';
import afBusiness from '../../../assets/accounting_financial_Services/business_Services.jpg';
import afFinancial from '../../../assets/accounting_financial_Services/financial_Services.jpg';
import vmBuy from '../../../assets/vehicle_marketplace/buy_vehicle.jpg';
import vmSell from '../../../assets/vehicle_marketplace/sell_vehicle.jpg';
import vmFinancing from '../../../assets/vehicle_marketplace/financing_vehicle.jpg';
import vmTradeIn from '../../../assets/vehicle_marketplace/trade_in.jpg';
import paRcic from '../../../assets/professionals_available/lawyer-signing-legal-documents.jpg';
import paLawyer from '../../../assets/professionals_available/lawyers.jpg';
import paAccountant from '../../../assets/professionals_available/accountants.jpg';
import paParalegal from '../../../assets/professionals_available/paralegals.jpg';
import type { HomeCardLayout } from './constants/homeCardLayouts';

export interface HomeTopicCard {
  categoryId: string;
  slug: string;
  title: string;
  shortDesc: string;
  image: string;
  badge?: string;
  badgeType?: 'demand' | 'free' | 'new';
  iconKey?: string;
  meta?: string;
  cardLayout?: HomeCardLayout;
  topicKey?: string;
  clickAction?: 'thread' | 'page';
  pagePath?: string;
}

export interface HomeTopicSectionConfig {
  id: string;
  cardLayout?: HomeCardLayout;
  eyebrow: string;
  eyebrowIcon?: string;
  eyebrowClass?: string;
  title: string;
  titleLead?: string;
  titleTail?: string;
  subtitle: string;
  comingSoonKey: 'service' | 'consultant';
  comingSoonEmoji: string;
  comingSoonTitle: string;
  comingSoonSub: string;
  items: HomeTopicCard[];
}

export const HOME_TOPIC_SECTIONS: HomeTopicSectionConfig[] = [
  {
    id: 'emergency',
    eyebrow: 'Emergency Assistance',
    eyebrowClass: 'ebento-eyebrow',
    title: 'Help is one tap away',
    subtitle: '24/7 emergency dispatch · Roadside, towing & accident support when you need it most',
    comingSoonKey: 'service',
    comingSoonEmoji: '🚑',
    comingSoonTitle: 'More services soon!',
    comingSoonSub: 'New emergency services will be added soon. Stay tuned!',
    items: [
      {
        categoryId: 'emergency',
        slug: 'accident-help',
        title: 'Accident Help',
        shortDesc: 'On-scene guidance, documentation & emergency responders.',
        image: emergAccident,
        badge: 'Live dispatch',
        badgeType: 'demand',
        meta: '~90s avg response',
      },
      {
        categoryId: 'emergency',
        slug: 'roadside-assist',
        title: 'Roadside Assistance',
        shortDesc: 'Tyre, battery, fuel — dispatched instantly.',
        image: emergRoadside,
        meta: '~15 min',
      },
      {
        categoryId: 'emergency',
        slug: 'towing',
        title: 'Towing Assistance',
        shortDesc: 'Verified tow operators, minutes away.',
        image: emergTowing,
        meta: '~25 min',
      },
      {
        categoryId: 'emergency',
        slug: 'vehicle-lockout',
        title: 'Vehicle Lockout',
        shortDesc: 'Certified locksmith on the way instantly.',
        image: emergLockout,
        meta: '~20 min',
      },
    ],
  },
  {
    id: 'legal',
    eyebrow: 'Legal & Immigration Assistance',
    eyebrowIcon: 'ti-scale',
    title: 'Navigate the legal system with confidence',
    titleLead: 'Navigate the legal system',
    titleTail: 'with confidence',
    subtitle: 'Licensed lawyers & immigration advisors · Traffic tickets, disputes & visa help',
    comingSoonKey: 'service',
    comingSoonEmoji: '⚖️',
    comingSoonTitle: 'More services soon!',
    comingSoonSub: 'New legal & immigration services will be added soon. Stay tuned!',
    items: [
      {
        categoryId: 'legal',
        slug: 'legal-consult',
        title: 'Legal Consultation',
        shortDesc: 'Talk to a legal expert — no commitment, no cost for the first session.',
        image: legalConsultation,
        badge: 'Free',
        badgeType: 'free',
        meta: 'First session free',
      },
      {
        categoryId: 'legal',
        slug: 'traffic-ticket',
        title: 'Traffic Tickets',
        shortDesc: 'Fight or resolve fines with expert guidance.',
        image: legalTraffic,
        meta: 'Court support',
      },
      {
        categoryId: 'legal',
        slug: 'fraud-disputes',
        title: 'Fraud & Disputes',
        shortDesc: 'Protect your rights and recover losses.',
        image: legalFraud,
        meta: 'Dispute help',
      },
      {
        categoryId: 'legal',
        slug: 'immigration',
        title: 'Immigration',
        shortDesc: 'PR, visas, work permits & family sponsorship.',
        image: legalImmigration,
        meta: 'PR · Visas · Permits',
      },
    ],
  },
  {
    id: 'financial',
    eyebrow: 'Accounting & Financial Services',
    eyebrowIcon: 'ti-receipt',
    title: 'Expert financial management & tax solutions',
    titleLead: 'Expert financial management',
    titleTail: '& tax solutions',
    subtitle: 'Certified CPAs & financial planners · Tax filing, insurance & business services',
    comingSoonKey: 'service',
    comingSoonEmoji: '💼',
    comingSoonTitle: 'More services soon!',
    comingSoonSub: 'New financial services will be added soon. Stay tuned!',
    items: [
      {
        categoryId: 'financial',
        slug: 'tax-services',
        title: 'Tax Services',
        shortDesc: 'CRA tax filing & returns with CPA support.',
        image: afTax,
        meta: 'CPA-certified',
      },
      {
        categoryId: 'financial',
        slug: 'insurance',
        title: 'Insurance',
        shortDesc: 'Life, health, auto & property coverage.',
        image: afInsurance,
        meta: 'Compare plans',
      },
      {
        categoryId: 'financial',
        slug: 'business-services',
        title: 'Business Services',
        shortDesc: 'Incorporation, bookkeeping & compliance.',
        image: afBusiness,
        meta: 'New arrivals',
      },
      {
        categoryId: 'financial',
        slug: 'financial-svcs',
        title: 'Financial Services',
        shortDesc: 'Wealth & investment planning tailored to you.',
        image: afFinancial,
        meta: 'Wealth planning',
      },
    ],
  },
  {
    id: 'vehicle',
    eyebrow: 'Vehicle Marketplace',
    eyebrowIcon: 'ti-car',
    title: 'Buy, sell, or finance your next vehicle',
    subtitle: 'Trusted dealers · Transparent pricing · No hidden fees',
    comingSoonKey: 'service',
    comingSoonEmoji: '🚗',
    comingSoonTitle: 'More services soon!',
    comingSoonSub: 'New vehicle marketplace services will be added soon. Stay tuned!',
    items: [
      {
        categoryId: 'vehicle',
        slug: 'buy-vehicle',
        title: 'Buy a Vehicle',
        shortDesc: 'Certified pre-owned or new vehicles with transparent pricing.',
        image: vmBuy,
        badge: 'Popular',
        badgeType: 'demand',
        meta: 'Certified stock',
        clickAction: 'page',
        pagePath: '/vehicles',
      },
      {
        categoryId: 'vehicle',
        slug: 'sell-vehicle',
        title: 'Sell Your Car',
        shortDesc: 'Free listing with fast offers from verified buyers.',
        image: vmSell,
        meta: 'Fast offers',
      },
      {
        categoryId: 'vehicle',
        slug: 'financing',
        title: 'Financing',
        shortDesc: 'Low rates with quick approval on your terms.',
        image: vmFinancing,
        meta: 'Quick approval',
      },
      {
        categoryId: 'vehicle',
        slug: 'trade-in',
        title: 'Trade-In Estimate',
        shortDesc: 'Get an instant estimate for your current vehicle.',
        image: vmTradeIn,
        meta: 'Instant quote',
      },
    ],
  },
  {
    id: 'professionals',
    eyebrow: 'Professionals Available',
    eyebrowIcon: 'ti-certificate',
    title: 'Verified experts, ready to help',
    subtitle: 'Verified RCICs, lawyers, accountants & paralegals — book or chat with an expert today',
    comingSoonKey: 'consultant',
    comingSoonEmoji: '👨‍💼',
    comingSoonTitle: 'More consultants soon!',
    comingSoonSub: 'New professionals will be onboarded soon. Stay tuned!',
    items: [
      {
        categoryId: 'professionals',
        slug: 'rcic',
        title: 'RCICs',
        shortDesc: 'Regulated immigration consultants ready to assist.',
        image: paRcic,
        meta: 'Regulated',
      },
      {
        categoryId: 'professionals',
        slug: 'lawyers',
        title: 'Lawyers',
        shortDesc: 'Licensed & experienced attorneys across practice areas.',
        image: paLawyer,
        meta: 'Licensed',
      },
      {
        categoryId: 'professionals',
        slug: 'accountants',
        title: 'Accountants',
        shortDesc: 'CPA-certified tax and bookkeeping specialists.',
        image: paAccountant,
        meta: 'CPA-certified',
      },
      {
        categoryId: 'professionals',
        slug: 'paralegals',
        title: 'Paralegals',
        shortDesc: 'Affordable legal support for everyday matters.',
        image: paParalegal,
        meta: 'Legal support',
      },
    ],
  },
];
